module.exports = __webpack_public_path__ + "img/img1.555ab3a8.jpg";